import {createAction, props} from '@ngrx/store';
import {DisplayState, ConfigurationScope} from './configuration.models';
import { HttpErrorState } from '../shared/error.models';

// FxRate interface confirmed with backend team
export interface FxRate {
  currency: string;
  rate: string;
  base_rate: string;
}

// Settings interface confirmed with backend team
export interface CoreSettingsResponse {
  open_syndicate_count: number;
  periods: Period[];
  sport_categories: SportCategory[];
  rebate_tiers: RebateTier[];
  fx_rates: FxRate[];
  free_play_tiers: FreePlayTier[];
  post_edit_window_in_miliseconds: number;
  post_delete_window_in_miliseconds: number;
  max_grouped_tickets: number;
  default_currency: string;
  // Additional fields that may be in response
  max_group_tickets?: number;
  settlement_threshold_commission?: number;
  currency_threshold?: number;
  win_commission?: string | number;
  reversed_wager_tax?: string | number;
}

export interface FreePlayTier {
  id: number;
  description: string;
  enabled: boolean;
  plays: number;
  stake_tier: number;
  from_threshold: string;
  to_threshold: null | string;
}

export interface Period {
  id: number;
  time_value: number;
  time_key: string;
  leaderboard_notification_order: number;
}

export interface RebateTier {
  id: number;
  description: string;
  rebate_percentage: string;
  from_threshold_units: null | string;
  to_threshold_units: null | string;
  vip: boolean;
  enabled: boolean;
}

export interface SportCategory {
  id: number;
  code: string;
  description: SportCategoryDescription;
  pools_count: number;
}

export interface SportCategoryDescription {
  sport_codes: string[];
}

export const callCoreSettings = createAction('[Configuration] Call Core');
export const callFxRates = createAction('[Configuration] Call Fx Rates');
export const successFxRates = createAction('[Configuration] Success Fx Rates',
    props<{
        response: FxRate[]
    }>());

export const successCoreSettings = createAction('[Configuration] Success Core',
    props<{
        response: CoreSettingsResponse
    }>());

export const setDisplayState = createAction('[Configuration] Set Display State',
    props<{
        displayState: DisplayState // add model
    }>());

export const setLocalSettings = createAction('[Configuration] Set Local Settings',
    props<{
        localSettings: Partial<ConfigurationScope.localSettings>
    }>());


export const failConfiguration = createAction('[Configuration] Fail',
    props<{
        error: HttpErrorState
    }>());

export const setUSState = createAction('[Configuration] Set US State',
  props<{
    usa_state: string
  }>());

export const setAllowCashBet = createAction('[Configuration] Set Allow Cash Bet',
  props<{
    allow_cash_bet: boolean
  }>());
